<ui-menu-list>
  <ui-menu-list-item icon="heroArrowTopRightOnSquare" (click)="clickOpen.emit()">
    {{ 'cockpit.documents.contextMenu.open' | transloco }}
  </ui-menu-list-item>
  <ui-menu-list-item
    *hasRole="'USER_ADMIN'"
    mode="admin"
    icon="heroPencilSquare"
    (click)="clickEdit.emit()"
  >
    {{ 'cockpit.documents.contextMenu.edit' | transloco }}
  </ui-menu-list-item>
  @if (!document().fileType.startsWith('LMA_')) {
    <app-document-download-button
      [document]="document()"
      [organizationID]="organizationId()"
      (click)="dismiss.emit()"
    >
      <ui-menu-list-item icon="heroArrowDownTray">
        {{ 'cockpit.documents.contextMenu.download' | transloco }}
      </ui-menu-list-item>
    </app-document-download-button>
  }
  <ui-menu-list-item icon="heroArrowUpOnSquare" (click)="clickShare.emit()" disableInDemoMode>
    {{ 'cockpit.documents.contextMenu.share' | transloco }}
  </ui-menu-list-item>
  <ui-menu-list-item
    *hasPermission="['ORGANIZATION_FILE_DELETE']"
    mode="destructive"
    icon="heroTrash"
    (click)="clickDelete.emit()"
  >
    {{ 'cockpit.documents.contextMenu.delete' | transloco }}
  </ui-menu-list-item>
</ui-menu-list>
